import React, { FC, useEffect } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'
import { useDropdownOptions } from 'src/components/Core/Context/OnboardingContext'

const CommunicationDetailsForm: FC<FormProps> = props => {
  const { dropdownOptions } = useDropdownOptions()

  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const {
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    toggleShowByName,
    configData,
  } = useForm(props.fetchedData, config({ countries: dropdownOptions.countries, countryTelephoneCodes: dropdownOptions.countryTelephoneCodes, formType: props.formType }), submitForm)

  useEffect(() => {
    toggleShowByName(
      'tradingAddress',
      formData?.isTradingAddressDifferent?.value === 'true'
    )
    toggleShowByName(
      'tradingCity',
      formData?.isTradingAddressDifferent?.value === 'true'
    )
    toggleShowByName(
      'tradingPostCode',
      formData?.isTradingAddressDifferent?.value === 'true'
    )
    toggleShowByName(
      'tradingCountry',
      formData?.isTradingAddressDifferent?.value === 'true'
    )
    toggleShowByName(
      'telephoneCountryIndex',
      formData?.isTradingAddressDifferent?.value === 'true'
    )
    toggleShowByName(
      'tradingTelephoneNo',
      formData?.isTradingAddressDifferent?.value === 'true'
    )
    toggleShowByName(
      'emailAddress',
      formData?.isTradingAddressDifferent?.value === 'true'
    )
  }, [formData?.isTradingAddressDifferent?.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t(
            'onboarding.forms.CorporateAccount.CommunicationDetailsForm.title'
          )}
        </FormTitle>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default CommunicationDetailsForm
